import React from 'react';
import moment from 'moment';
export var RewardsCardDetail = function RewardsCardDetail(props) {
  var thumbnailImageClass = '';
  var detailContainerClass = '';
  var showTag = false;

  switch (props.activityCardType) {
    case 'SPIN_PEG_REWARD':
      thumbnailImageClass = 'cb-account-card__detail__image-container--spin-peg-reward';
      detailContainerClass = 'cb-account-card__detail--spin-peg-reward';
      break;

    case 'REWARD_EARNED':
      showTag = true;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card__detail ".concat(detailContainerClass)
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card__detail__image-container ".concat(thumbnailImageClass)
  }, /*#__PURE__*/React.createElement("img", {
    src: props.rewardDetailThumbnailImage,
    alt: 'Thumbnail Image'
  }), showTag && /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card__detail__tag"
  }, "Reward")), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card__detail__text"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-account-card__detail__text-header'
  }, props.rewardDetailHeader || ''), /*#__PURE__*/React.createElement("div", {
    className: 'cb-account-card__detail__text-description'
  }, props.rewardDetailDescription || ''), props.couponStatus === 'used' && props.rewardRedeemedDatetime ? /*#__PURE__*/React.createElement("div", {
    className: 'cb-account-card__detail__text-redeemed-expired'
  }, "Redeemed ".concat(moment(props.rewardRedeemedDatetime).format('M/D/YY'))) : props.rewardExpirationDatetime ? /*#__PURE__*/React.createElement("div", {
    className: 'cb-account-card__detail__text-redeemed-expired'
  }, "".concat(props.couponStatus === 'expired' ? 'Expired' : 'Expires', " ").concat(moment(props.rewardExpirationDatetime).format('M/D/YY'))) : null));
};